// Add at top of file
const TRANSLATED_SLUGS = {
  women: document.body.dataset.womenPageSlug || 'women',
  men: document.body.dataset.menPageSlug || 'men',
  dg: document.body.dataset.dgPageSlug || 'dolce-gabbana'
};

/***********************************************************
 * 1) POST HELPER
 ************************************************************/
async function postData(url = '', data = {}) {
    const response = await fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data),
    });
    if (!response.ok) throw new Error(`HTTP ${response.status}: ${response.statusText}`);
    return response.json();
}

let isUpdating = false; // Prevents multiple cart updates at the same time

/***********************************************************
 * 2) HELPER: Detect if Root or Localized Root
 ************************************************************/
function isRootOrLocalizedRoot() {
  const parts = window.location.pathname.split('/').filter(Boolean);

  // "/" => no segments
  if (parts.length === 0) {
    return true;
  }

  // "/fr", "/en", "/en-us", "/fr-ca", etc. => single segment
  // If you have 3-letter codes, use ^[a-z]{2,3}(-[a-z]{2,3})?$
  if (parts.length === 1) {
    return /^[a-z]{2}(-[a-z]{2})?$/.test(parts[0]);
  }

  // More than one path segment => not a root/localized root
  return false;
}

document.addEventListener("DOMContentLoaded", function () {
    const currentGenderNav = document.body.dataset.currentGenderNav || "header-group-home";
    const currentPath = window.location.pathname.toLowerCase();
    const strippedPath = currentPath.replace(/^\/[a-z]{2}(-[a-z]{2})?\//, '/'); // Remove subfolder (like /it/, /fr/)
    const productTags = window.productTags || []; // Ensure global productTags are available
    const productVendor = window.productVendor?.toLowerCase();
    const collectionGender = (window.collectionGender || document.body.dataset.collectionGender || "").toLowerCase();
    const pageHeaderGroup = document.body.dataset.pageHeaderGroup || '';
    const referrer = document.referrer;

    const genderHeaderMap = {
        "gender female": "header-group-women",
        "gender men":    "header-group-men",
    };

    /***********************************************************
     * 3) CART ATTRIBUTE UPDATE
     ************************************************************/
    function setCartAttribute(attribute, value) {
        // Skip if theme.liquid is already handling the cart update
        if (window.isUpdatingHeader) return;

        // 1) Skip forced reload only if:
        //    - It's the user's FIRST visit, AND
        //    - They're on the root/localized root homepage
        if (!sessionStorage.getItem('visitedSiteBefore') && isRootOrLocalizedRoot()) {
            return;
        }

        // 2) Existing condition: if on root/localized root (regardless of first visit)
        //    => skip gender-nav logic
        if (isRootOrLocalizedRoot()) {
            return;
        }

        // Everything else remains unchanged
        if (isUpdating) return;
        if (currentGenderNav === value) return;
        if (sessionStorage.getItem('currentPage') === window.location.pathname) return;

        isUpdating = true;
        fetch("/cart/update.js", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ attributes: { [attribute]: value } })
        }).then(() => {
            isUpdating = false;
            sessionStorage.setItem('currentPage', window.location.pathname);
            document.body.dataset.currentGenderNav = value;
            // Cart attribute synced for next navigation — no reload needed
        }).catch((err) => {
            isUpdating = false;
            console.error("[setCartAttribute] Failed to update cart attribute:", err);
        });
    }

    /***********************************************************
     * 4) PAGE-LEVEL LOGIC
     ************************************************************/
    function handlePageLogic() {
        if (pageHeaderGroup && currentGenderNav !== pageHeaderGroup) {
            setCartAttribute("gender_nav", pageHeaderGroup);
        }
    }

    /***********************************************************
     * 5) DOLCE & GABBANA PRIORITY LOGIC
     ************************************************************/
    function handleDolceGabbanaPriority() {
        const normalizedVendor = productVendor?.toLowerCase();
        const expectedVendor = "dolce & gabbana";

        // D&G always gets D&G nav — no session guard needed
        if (normalizedVendor === expectedVendor || productTags.some(tag => tag.toLowerCase() === expectedVendor)) {
            if (currentGenderNav !== "header-group-dolce-gabbana") {
                setCartAttribute("gender_nav", "header-group-dolce-gabbana");
            }
            return true;
        }

        if (collectionGender === "dolce-gabbana") {
            if (currentGenderNav !== "header-group-dolce-gabbana") {
                setCartAttribute("gender_nav", "header-group-dolce-gabbana");
            }
            return true;
        }

        // Fallback: path check (brand name never translates)
        if (strippedPath.includes('/pages/dolce-gabbana')) {
          if (currentGenderNav !== "header-group-dolce-gabbana") {
            setCartAttribute("gender_nav", "header-group-dolce-gabbana");
          }
          return true;
        }

        return false;
    }

    /***********************************************************
     * 6) PRODUCT-BASED LOGIC
     ************************************************************/
    function handleProductLogic() {
        if (!strippedPath.includes("/products/")) return;

        // D&G products always get D&G nav (handled by priority function)
        if (handleDolceGabbanaPriority()) return;

        // Non-D&G products: gender tags always determine the nav
        productTags.some(tag => {
            const targetHeaderType = genderHeaderMap[tag.toLowerCase()];
            if (targetHeaderType && currentGenderNav !== targetHeaderType) {
                setCartAttribute("gender_nav", targetHeaderType);
                return true;
            }
        });
    }

    /***********************************************************
     * 7) COLLECTION-BASED LOGIC
     * Primary: collection metafield (language-agnostic)
     * Fallback: English handle path match (handles never change per locale)
     ************************************************************/
    function handleCollectionLogic() {
        if (!strippedPath.includes("/collections/")) return;

        if (currentGenderNav === 'header-group-women' || currentGenderNav === 'header-group-men') {
            return;
        }

        // Primary detection: metafield (works for all languages)
        if (collectionGender === "women" && currentGenderNav !== "header-group-women") {
            setCartAttribute("gender_nav", "header-group-women");
            return;
        } else if (collectionGender === "men" && currentGenderNav !== "header-group-men") {
            setCartAttribute("gender_nav", "header-group-men");
            return;
        }

        // Fallback: English handle path match (Shopify handles are always English)
        if (collectionGender === "") {
            if (strippedPath.includes('/collections/women')) {
                setCartAttribute("gender_nav", "header-group-women");
            } else if (strippedPath.includes('/collections/men')) {
                setCartAttribute("gender_nav", "header-group-men");
            }
        }
    }

    /***********************************************************
     * 8) DIRECT ENTRY LOGIC
     ************************************************************/
    function handleDirectEntryLogic() {
        let isDirectEntry = true;
        try { isDirectEntry = !referrer || new URL(referrer).hostname !== location.hostname; } catch (e) { /* malformed referrer */ }

        if (isDirectEntry) {
            if (isRootOrLocalizedRoot()) {
                return;
            }

            if (currentGenderNav === "header-group-women" || currentGenderNav === "header-group-men") {
                return;
            }

            let targetHeaderType = currentGenderNav;

            if (strippedPath.includes("/products/")) {
                targetHeaderType = productVendor === "dolce & gabbana"
                  ? "header-group-dolce-gabbana"
                  : productTags.some(t => t.toLowerCase() === "gender men")
                    ? "header-group-men"
                    : productTags.some(t => t.toLowerCase() === "gender female")
                      ? "header-group-women"
                      : currentGenderNav;
            }

            if (strippedPath.includes("/collections/") && collectionGender) {
                targetHeaderType = collectionGender === "men"
                  ? "header-group-men"
                  : collectionGender === "women"
                    ? "header-group-women"
                    : collectionGender === "dolce-gabbana"
                      ? "header-group-dolce-gabbana"
                      : currentGenderNav;
            }

            if (targetHeaderType && currentGenderNav !== targetHeaderType) {
                setCartAttribute("gender_nav", targetHeaderType);
            }
        }
    }

    /***********************************************************
     * 9) RUN THE LOGIC
     ************************************************************/
    handlePageLogic();
    handleDolceGabbanaPriority();
    handleProductLogic();
    handleCollectionLogic();
    handleDirectEntryLogic();
});


/***********************************************************
 * 10) NAVIGATION LOGIC FOR LINKS
 ************************************************************/
document.body.addEventListener("click", function (e) {
    const link = e.target.closest("a");
    if (!link || !link.href) return;

    if (isRootOrLocalizedRoot()) {
        return;
    }

    const url = new URL(link.href);
    const decodedPath = decodeURIComponent(url.pathname);
    const pathLower = decodedPath.toLowerCase();
    const strippedPath = pathLower.replace(/^\/[a-z]{2}(-[a-z]{2})?\//, '/');
    const subfolderPath = window.location.pathname.split('/').filter(Boolean)[0];
    let headerType = document.body.dataset.currentGenderNav || "header-group-home";

    // Handle home button/logo click
    if (strippedPath === '/' || pathLower === `/${subfolderPath}/`) {
        e.preventDefault();

        const isSingleSubfolder = /^[a-z]{2}$/.test(subfolderPath);
        const isMultiSubfolder = /^[a-z]{2}-[a-z]{2}$/.test(subfolderPath);
        const basePath = isSingleSubfolder || isMultiSubfolder ? `/${subfolderPath}` : '';

        let targetPath = `${basePath}/`;
        if (headerType === "header-group-women") {
            targetPath = `${basePath}/pages/${TRANSLATED_SLUGS.women}`;
        } else if (headerType === "header-group-men") {
            targetPath = `${basePath}/pages/${TRANSLATED_SLUGS.men}`;
        } else if (headerType === "header-group-dolce-gabbana") {
            targetPath = `${basePath}/pages/${TRANSLATED_SLUGS.dg}`;
        }

        window.location.href = targetPath;
        return;
    }

    const headerTypeMap = {
        'women': "header-group-women",
        'men': "header-group-men",
        'dolce-gabbana': "header-group-dolce-gabbana",
        [TRANSLATED_SLUGS.women]: "header-group-women",
        [TRANSLATED_SLUGS.men]: "header-group-men",
        [TRANSLATED_SLUGS.dg]: "header-group-dolce-gabbana"
    };

    let newHeaderType = "";

    if (strippedPath.startsWith("/collections/") || strippedPath.startsWith("/pages/")) {
        const detectedSlug = Object.entries(headerTypeMap).find(([slug]) => {
            return strippedPath.startsWith(`/pages/${slug}`) || strippedPath.startsWith(`/collections/${slug}`);
        });

        newHeaderType = detectedSlug ? detectedSlug[1] : "";
    }

    if (newHeaderType && newHeaderType !== headerType) {
        e.preventDefault();
        if (!isUpdating) {
            isUpdating = true;
            postData("/cart/update.js", { attributes: { gender_nav: newHeaderType } }).then(() => {
                isUpdating = false;
                window.location.href = link.href;
            }).catch((err) => {
                isUpdating = false;
                console.error("[NavClick] Cart update failed, navigating anyway:", err);
                window.location.href = link.href;
            });
        }
    }
});

